export const tagPickerInputCSSRules = {
    width: '--fluent-TagPickerInput__width'
};
export const tagPickerInputTokens = {
    width: `var(${tagPickerInputCSSRules.width}, 0)`
};
